import az from "../lib/translations/MagicRFE/enjson_az.json";
import bg from "../lib/translations/MagicRFE/enjson_bg.json";
import cs from "../lib/translations/MagicRFE/enjson_cs.json";
import da from "../lib/translations/MagicRFE/enjson_da.json";
import de from "../lib/translations/MagicRFE/enjson_de.json";
import el from "../lib/translations/MagicRFE/enjson_el.json";
import en from "../lib/translations/MagicRFE/enjson_en.json";
import en_US from "../lib/translations/MagicRFE/enjson_en_US.json";
import es from "../lib/translations/MagicRFE/enjson_es.json";
import es_MX from "../lib/translations/MagicRFE/enjson_es_MX.json";
import et from "../lib/translations/MagicRFE/enjson_et.json";
import fi from "../lib/translations/MagicRFE/enjson_fi.json";
import fr_CA from "../lib/translations/MagicRFE/enjson_fr_CA.json";
import hr from "../lib/translations/MagicRFE/enjson_hr.json";
import hu from "../lib/translations/MagicRFE/enjson_hu.json";
import hy from "../lib/translations/MagicRFE/enjson_hy.json";
import id from "../lib/translations/MagicRFE/enjson_id.json";
import it from "../lib/translations/MagicRFE/enjson_it.json";
import it_IT from "../lib/translations/MagicRFE/enjson_it_IT.json";
import ja_JP from "../lib/translations/MagicRFE/enjson_ja_jp.json";
import ka from "../lib/translations/MagicRFE/enjson_ka.json";
import kk from "../lib/translations/MagicRFE/enjson_kk.json";
import lt from "../lib/translations/MagicRFE/enjson_lt.json";
import lv from "../lib/translations/MagicRFE/enjson_lv.json";
import nb from "../lib/translations/MagicRFE/enjson_nb.json";
import nl from "../lib/translations/MagicRFE/enjson_nl.json";
import pt from "../lib/translations/MagicRFE/enjson_pt.json";
import pt_BR from "../lib/translations/MagicRFE/enjson_pt_BR.json";
import ro from "../lib/translations/MagicRFE/enjson_ro.json";
import ru from "../lib/translations/MagicRFE/enjson_ru.json";
import sk from "../lib/translations/MagicRFE/enjson_sk.json";
import sl from "../lib/translations/MagicRFE/enjson_sl.json";
import sq from "../lib/translations/MagicRFE/enjson_sq.json";
import sv from "../lib/translations/MagicRFE/enjson_sv.json";
import tr from "../lib/translations/MagicRFE/enjson_tr.json";
import uz from "../lib/translations/MagicRFE/enjson_uz.json";
import zh_CN from "../lib/translations/MagicRFE/enjson_zh_CN.json";
import zh_TW from "../lib/translations/MagicRFE/enjson_zh_TW.json";

const resource = {
  MagicRFE: {
    az,
    bg,
    cs,
    da,
    de,
    el,
    en,
    en_US,
    es,
    es_MX,
    et,
    fi,
    fr_CA,
    hr,
    hu,
    hy,
    id,
    it,
    it_IT,
    ja_JP,
    ka,
    kk,
    lt,
    lv,
    nb,
    nl,
    pt,
    pt_BR,
    ro,
    ru,
    sk,
    sl,
    sq,
    sv,
    tr,
    uz,
    zh_CN,
    zh_TW
  }
};

export const getResourceFile = settings => {
  const DEFAULT_LANGUAGE = "en";
  const DEFAULT_APP = "MagicRFE";

  const applicationName = settings
    ? settings !== ""
      ? resource[settings.applicationName]
        ? settings.applicationName
        : DEFAULT_APP
      : DEFAULT_APP
    : DEFAULT_APP;

  const language = settings
    ? settings !== ""
      ? settings.language
        ? settings.language !== ""
          ? settings.language
          : DEFAULT_LANGUAGE
        : DEFAULT_LANGUAGE
      : DEFAULT_LANGUAGE
    : DEFAULT_LANGUAGE;

  const languageJSON = language.replace("-", "_");
  const languageWithoutRegionCode = languageJSON
    .toLowerCase()
    .split(/[_-]+/)[0];

  const resources = resource[applicationName][languageJSON]
    ? resource[applicationName][languageJSON]
    : resource[applicationName][languageWithoutRegionCode.split(/[_-]+/)[0]];

  return { language: language, messages: resources };
};
